import React from 'react';
import { Briefcase } from 'lucide-react';
import PortalLoginShell from './PortalLoginShell';

export default function StaffLogin() {
  return (
    <PortalLoginShell
      badge="For Staff"
      title="Staff Login"
      subtitle="Access your assigned modules and manage your profile."
      expectedRole={["staff", "manager", "counsellor"]}
      onSuccessPath="/staff-dashboard"
      iconBg="bg-tge-gold"
      Icon={Briefcase}
      emailPlaceholder="you@trueglobaleducation.com"
      testidPrefix="staff-login"
      footerLink={null}
    />
  );
}
